<template>
  <div id="data-list-thumb-view" class="data-list-container">

    <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" search :data="product_variant">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center">
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ product_variant.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : product_variant.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>Image</vs-th>
        <vs-th sort-key="name">Product</vs-th>
        <vs-th sort-key="sku">SKU</vs-th>
        <vs-th sort-key="category_name">Category</vs-th>
        <vs-th sort-key="inventory_count">Stock</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="tr.variant_id" v-for="(tr, indextr) in data">
            <vs-td class="img-container d-sm-table-cell">
             <img v-if="tr.image !== ''" :src="tr.image.feature.Location" ref="product-image" class="product-img" />
             <img v-else src="@/assets/images/pages/default-product.png" ref="product-image" class="product-img" />
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.name }}</p>

              <p class="product-name font-medium truncate" :data="trx" :key="indextrx" v-for="(trx, indextrx) in tr.option">{{trx.label}}: {{trx.value}}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.sku }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.category_name }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.inventory_count }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
              <vx-tooltip text="Edit Stock">
              <feather-icon icon="EditIcon" :variant_id="tr.variant_id" :index="indextr" :inventory_count="tr.inventory_count" @click.stop="editInventory"/>
              </vx-tooltip>
              </vs-col>
              
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
                <vx-tooltip text="View Logs">
              <feather-icon icon="FileTextIcon"  @click.stop="viewHistory(tr.variant_id)"/>
              </vx-tooltip>
              </vs-col>
            </vs-td>

          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-popup class="holamundo"  title="Inventory History" :active.sync="popup" >
      <vs-table pagination :max-items="10" search :data="logs">
        <template slot="thead">
        <vs-th sort-key="create_at">Date</vs-th>
        <vs-th>Remarks</vs-th>
        <vs-th>Order ID</vs-th>
        <vs-th>Inventory</vs-th>
      </template>
      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="tr.variant_id" v-for="(tr, indextr) in data" >
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.create_at }}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.remarks }}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.order_id }}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.quantity }}</p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
      </vs-table>
    </vs-popup>

    <vs-popup class="holamundo" vs-justify="center" vs-align="center" title="Edit Stock" :active.sync="inv_popup" :data="inv_pop">
      <vs-row>
        <vs-col vs-w="12"  vs-type="flex" vs-justify="center" vs-align="center" >
        <div vs-justify="center" vs-align="center">
        <table>
        <tr>
          <td>Stock movement (Qty) </td>
          <td><vs-input-number vs-min="-999" vs-max="999" step="1" v-model="inv_pop.adjust_stock" @input="adjustAvailableStock"/></td>
        </tr>

        <tr>
          <td>Remark </td>
          <td><vs-input class="inputx" placeholder="Admin Update" v-model="inv_pop.remark"/></td>
        </tr>

        <tr>
          <td>New stock availability (Qty)</td>
          <td><vs-input class="inputx" v-model="inventory_stock" disabled/></td>
        </tr>
        </table>
        <vs-button class="popup-close" color="primary" :style="'position: right'" type="filled" :variant_id="inv_pop.variant_id" @click.stop="updateInventory">Save</vs-button>
        </div>
        </vs-col>
      </vs-row>
    </vs-popup>

  </div>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      selected: [],
      // product_variant: [],
      itemsPerPage: 4,
      isMounted: false,
      popup: false,
      inv_popup: false,
      outOfNumber: false,
      cur: {},
      counter: 0,
      inventory_stock: 0,
      logs: '',
      inv_pop: {variant_id:0,index:0,inventory_count:0,adjust_stock:0,remark:'Admin Update'},
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    product_variant () {
      return JSON.parse(JSON.stringify(this.$store.state.inventory.product_variant));
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.product_variant.length
    }
  },
  watch:{
    inv_popup: function (val) { //detect inv_popup close event
      if(!val){this.reset_inv_pop()}
    }
  },
  methods: {
    getCheck (value) {
      if(this.cur.label !== value.label){
        this.cur = value
        this.counter = 1
      } else {
        this.counter++
      }
      return cur;
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    async viewHistory (val = '') {
      this.$vs.loading()
      await this.$store.dispatch('inventory/inventoryLog', val)
      .then(() => {
         this.$vs.loading.close();
         let temp = '';
         if(typeof this.$store.state.inventory.inventory_variant_log[val] !== 'undefined'){
          temp = this.$store.state.inventory.inventory_variant_log[val];
         }
         this.logs = temp;
         this.popup = true;
      })
    },

    editInventory (e) {
      if(e.target.parentElement.getAttribute('variant_id') !== null){
        var target = e.target.parentElement;
      }else{
        var target = e.target.parentElement.parentElement;
      }
      var variant_id = target.getAttribute('variant_id');
      var index = target.getAttribute('index');
      var inventorycount = target.getAttribute('inventory_count');
      this.inv_pop.variant_id = variant_id;
      this.inv_pop.index = index;
      this.inv_pop.inventory_count = inventorycount;
      this.inv_popup = true;
      this.inventory_stock = inventorycount;
      document.querySelector("button.vs-input-number--button-less").classList.remove('limit');
    },
    adjustAvailableStock(){
        var temp_val = parseInt(this.inv_pop.inventory_count) + parseInt(this.inv_pop.adjust_stock);
        if(temp_val > 0){
          setTimeout(() =>{document.querySelector("button.vs-input-number--button-less").classList.remove('limit');}, 100);
        }else{
          this.inv_pop.adjust_stock = '-'+this.inv_pop.inventory_count;
          temp_val = 0;
          document.querySelector("button.vs-input-number--button-less").classList.add('limit');
        }
        this.inventory_stock = temp_val;
    },
    updateInventory(){
      
      var stock_movement = parseInt(this.inv_pop.adjust_stock);

      this.$store.dispatch('inventory/updateInventoryLog',{id :this.inv_pop.variant_id, inventory_count: parseInt(stock_movement), remarks: this.inv_pop.remark});
      this.$store.commit('inventory/UPDATE_PRODUCT_VARIANTS',{index:parseInt(this.currentPage * this.itemsPerPage - (this.itemsPerPage - 1) -1)+parseInt(this.inv_pop.index),inventory_count: parseInt(this.inventory_stock)});
      this.inv_popup = false;
      this.reset_inv_pop();
    },
    reset_inv_pop(){
      this.inv_pop.variant_id = 0;
      this.inv_pop.index = 0;
      this.inv_pop.inventory_count = 0;
      this.inv_pop.adjust_stock = 0;
      this.inv_pop.remark = 'Admin Update';
      this.inventory_stock = 0;
    }
  },
  async created () {
    await this.$store.dispatch('inventory/productVariantList');
  },
  mounted () {
    this.isMounted = true,
    this.inv_pop.variant_id = 0;
    this.inv_pop.index = 0;
    this.inv_pop.inventory_count = 0;
    this.inv_pop.adjust_stock = 0;
    this.inv_pop.remark = 'Admin Update';
    this.inventory_stock = 0;
  }
}
</script>

<style lang="scss">
.empty {
  display: grid;
  margin-top: 10rem;
  img {
    justify-self: center;
    align-self: center;
    width: 200px;
  }
}

.vs-tooltip {
  z-index: 62000;
}
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
                width: 150px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

#data-list-thumb-view .vs-con-table .product-name {
    max-width: 11rem;
}

.variant-popup {
  z-index: 63000;
}

.variant-table{
    tbody{
       border: 0.5px solid lightpink;
      tr {
        border: 0.5px solid lightpink;
        td {
          border: 0.5px solid lightpink;
        }
      }
    }
}

.popup-container{
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  place-items: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 53000;
  background:rgba(255,255,255,.6);
  height:100%;
  transition: all .25s ease;
  -webkit-transition: all .25s ease;
}

.container:last-of-type{
  display: none;
}

.card {
  min-height: 80vh;
  width: 35rem;
  border-radius: 30px;
  padding: 0rem 5rem;
  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.2), 0px 0px 50px rgba(0, 0, 0, 0.2);
  background: white;
}

.product {
  min-height: 35vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-image {
  width: 15rem;
  // transform: translateX(20px); 
}

.cross-icon {
   position:absolute;
   bottom:90px;
   left: 90px;
}

.info h5{
  padding: 2rem 0rem;
  color: #585858;
  font-weight: lighter;
}

.variation{
  display: flex;
  justify-content: space-between;
}

.edit {
  margin-top: 2rem;
}

.edit button {
  width: 100%;
  padding: 1rem 0rem;
  background: #F9278E;
  border: none;
  color: white;
  cursor: pointer;
  border-radius: 30px;
}

</style>
